import $ from 'jquery';
import jQueryBridget from 'jquery-bridget';
import Flickity from 'flickity';
jQueryBridget('flickity', Flickity, $);

$('.js-carousel').each((index, carousel) => {
  const $carousel = $(carousel);
  const $carouselFlickity = $carousel.find('.js-carousel-flickity');
  const $carouselElements = $carousel.find('.js-carousel-element');
  const $carouselPrevious = $carousel.find('.js-carousel-previous');
  const $carouselNext = $carousel.find('.js-carousel-next');
  const $carouselHeading = $carousel.find('.js-carousel-heading');

  let options = {
    contain: true,
    draggable: true,
    freeScroll: false,
    pageDots: false,
    prevNextButtons: false,
    wrapAround: true,
  };

  if (window.matchMedia('(max-width: 1600px)').matches) {
    options.freeScroll = true;
  }

  $carouselFlickity.flickity(options);

  $carouselPrevious.on('click', () => {
    $carouselFlickity.flickity('previous');
  });

  $carouselNext.on('click', () => {
    $carouselFlickity.flickity('next');
  });

  $carouselFlickity.on('change.flickity', (event, index) => {
    const heading = $carouselElements.eq(index).attr('data-heading');
    $carouselHeading.text(heading);
  });
});
